
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.941 5.04L9.431.09C9.364.03 9.3-.003 9.212 0c-.172.008-.39.124-.39.3v2.483c0 .075-.063.142-.141.154C3.2 3.743.893 7.68.077 11.768c-.031.162.195.312.3.184 2-2.419 4.434-3.997 8.28-4.028.086 0 .165.098.165.18v2.438c0 .262.363.379.566.199l5.55-5.037a.406.406 0 00.136-.315c-.004-.12-.035-.258-.133-.348z","fill":"#FFC658"}})])
          )
        }
      }
    